import { observable, action, computed, createTransformer, reaction } from "mobx";
import {arrayToString, getByAtribute, stringToArray} from "../../../utils/formatar";
import ProdutoService from "../../../services/ProdutoService";
import JustificativaContratacaoService from "../../../services/JustificativaContratacaoService";

export default class ProdutoStore {

    @observable produtoLista;
    @observable itemSelecionado;
    @observable justificativaContratacoes
    @observable loading;
    @observable produtosFiltrados;

    constructor(modalStore) {
        this.modalStore = modalStore;
        this.produtoLista = [];
        this.resetItemSelecionado();
        this.justificativaContratacoes = [];
        this.produtoService = new ProdutoService();
        this.justificativasDeContratacaoService = new JustificativaContratacaoService();
    }

    resetItemSelecionado() {
        this.itemSelecionado = {
            id: undefined,
            codigo: "",
            nome: "",
            justificativaContratacaoId: "",
            justificativaContratacao: {
                id: 0,
                nome: ""
            },
            descricaoMot: "",
            sistemaAlocacao: "PCP",
            ativo: true
        };
    }

    filtrarProdutos(input, callback) {
        let result = [];
        let codigo = null;
        let prefixoNome = null;
        isNaN(input) ? prefixoNome = input : codigo = input;
        if(input && input.length > 1) {
            this.produtoService.listByPrefixoDescricaoEbsECodigo(prefixoNome, codigo).then(response => {
                this.produtosFiltrados = response.data;
                callback(null, {
                    options: response.data.map(produto => {
                        return {"value":produto.codigo, "label": produto.codigo + " - " + produto.descricao };
                    }),
                    complete: false
                });
            }).catch(error => {
                callback(null, {
                    options: result,
                    complete: false
                });
                console.log(error)
            });
        } else {
            callback(null, {options: result,complete: false});
        }

    }

    carregarLista() {
        this.loading = true;

        const loadingPromises = Promise.all([
            this.produtoService.list().then(response => {
                this.produtoLista = response.data;
            }).catch(error => {
                console.log(error);
            }),

            this.justificativasDeContratacaoService.list().then(response => {
                this.justificativaContratacoes = response.data;
            }).catch(error => {
                console.log(error);
            })
        ])
        loadingPromises.then(
            () => {
                this.loading = false;
            }
        ).catch(
            (error) => this.loading = false
        )
    }

    toggleAtivo() {
        this.itemSelecionado.ativo = !this.itemSelecionado.ativo;
    }

    setJustificativaContratacaoId(value) {
        this.itemSelecionado.justificativaContratacaoId = value;
        this.itemSelecionado.justificativaContratacao = getByAtribute(this.justificativaContratacoes,value,"id")
    }

    setSistemaAlocacao(value) {
        this.itemSelecionado.sistemaAlocacao = value;
    }

    setDescricaoMot(value) {
        this.itemSelecionado.descricaoMot = value;
    }

    setCodigo(value) {
        const produto = getByAtribute(this.produtosFiltrados,value,"codigo")
        this.itemSelecionado.codigo = value;
        this.itemSelecionado.nome = produto.descricao;
    }

    setLista(value) {
        this.produtoLista = value;
    }

    preencherModal(row){
        if(row) {
            this.itemSelecionado = Object.assign({}, row);
        } else {
            this.resetItemSelecionado();
        }
    }

    editar() {
        let tabelaIndex = this.produtoLista.findIndex((tabelaItem) => tabelaItem.id === this.itemSelecionado.id);
        this.produtoLista[tabelaIndex] = this.itemSelecionado;

        return this.produtoService.edit(this.itemSelecionado.id, this.itemSelecionado).then(response =>  {
            this.produtoLista[tabelaIndex] = response.data;
        })
    }

    cadastrar() {
        return this.produtoService.save(this.itemSelecionado).then(response => {
            this.produtoLista.push(response.data);
        });
    }

    remover() {
        let tabelaIndex = this.produtoLista.findIndex((tabelaItem) => tabelaItem.id === this.itemSelecionado.id);
        let modal = this.modalStore;

        return this.produtoService.delete(this.itemSelecionado.id).then(response => {
            this.produtoLista.splice(tabelaIndex, 1);
            modal.toggleModal()
        }).catch(error => {
            modal.setSubmitMensagemErro(error.response.data.message)
        })
    }


}